import { Navigate, Outlet } from 'react-router-dom';
import { useParams, useLocation } from 'react-router';

import {
    UserValidator,
    set_global_state,
    get_search_parameters,
} from 'functions';
import { Header, Footer } from 'components';

export default function AuthedRoutes() {
    let params = Object.assign(get_search_parameters(), useParams());
    set_global_state('params', params, true);
    let location = useLocation();
    set_global_state('location', location);

    let checker = new UserValidator();
    let is_logged_in = checker.logged_id();

    return is_logged_in ? (
        <div>
            <Header role={checker.get_role()} />
            <Outlet />
            <Footer />
        </div>
    ) : (
        <Navigate to="/login" />
    );
}
